import reducer from './reducers';

export { default as externalCpdActions } from './actions';
export { default as externalCpdSagas } from './sagas';
export * from './selectors';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/index.js